import React, { useEffect, useState } from 'react'

import { useLoading } from '../../Provider/LoadingProvider'
import { columnsAccessConfig } from '../../components/Tables/AccessConfig/Columns'
import FormAccessConfig from '../../components/Tables/AccessConfig/Form'
import { Pagination } from '../../types/types'
import './style.scss'

import { IconButton } from '@mui/material'
import { useAuth } from '../../Provider/AuthProvider'
import Modal from '../../components/GeneralComponents/Modal'
import Table from '../../components/Table'
import DeleteButton from '../../components/Table/components/DeleteButton'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { deleteAccessConfig, listAccessConfig } from '../../services/AccessConfig'
import { AccessConfig } from '../../types/AccessConfig'

const AccessConfigPage = () => {
  const { user } = useAuth()
  const [data, setData] = useState<Pagination<AccessConfig>>({
    currentPage: 1,
    hasNextPage: false,
    hasPrevPage: false,
    total: 1,
    totalPages: 1,
    data: []
  })
  const limit = 6
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [search, setSearch] = useState('')
  const [filteredBySearch, setFilteredBySearch] = useState(false)
  const [selected, setSelected] = useState<AccessConfig | undefined>(undefined)

  const { startLoading, stopLoading } = useLoading()

  useEffect(() => {
    getData(search.length > 3 ? search : '', data.currentPage)
  }, [])

  useEffect(() => {
    if (search.length >= 3) {
      setFilteredBySearch(true)
      getData(search, 1)
    } else if (filteredBySearch) {
      setFilteredBySearch(false)
      getData('', 1)
    }
  }, [search])

  useEffect(() => {
    getData(search, data.currentPage)
  }, [data.currentPage])

  useEffect(() => {
    if (selected) {
      setIsOpenModal(true)
    }
  }, [selected])

  const onCloseModal = () => {
    setIsOpenModal(false)
    setSelected(undefined)
  }

  const handleOpenModal = () => {
    setIsOpenModal(true)
  }

  const getData = async (searchValue: string, page: number) => {
    try {
      startLoading()
      const access = await listAccessConfig({
        params: { page, search: searchValue, limit },
        id: user?.clientId as string
      })
      setData(access)
    } catch (error) {
      console.error(error)
    } finally {
      stopLoading()
    }
  }

  const handleSubmit = async () => {
    setSelected(undefined)
    setIsOpenModal(false)
    await getData(search.length > 3 ? search : '', data.currentPage)
  }

  const handlePageChange = (newPage: number) => {
    getData(search.length >= 3 ? search : '', newPage)
  }

  const handleDelete = async (id: string) => {
    try {
      startLoading()
      await deleteAccessConfig(id)
      await getData(search.length > 3 ? search : '', data.currentPage)
    } catch (error) {
      console.error(error)
    } finally {
      stopLoading()
    }
  }

  const handleView = (value: AccessConfig) => {
    setSelected(value)
  }

  const Actions = ({ id, item }: { id: string; item: AccessConfig }) => {
    return (
      <div className="actionsContainer">
        <IconButton onClick={() => handleView(item as AccessConfig)}>
          <VisibilityIcon style={{ color: 'white' }} />
        </IconButton>

        <DeleteButton OnDelete={() => handleDelete(id)} />
      </div>
    )
  }

  return (
    <>
      <div className="checkPointsContainer">
        <div className="titleCheckPoints">
          <h4>CHECKINS</h4>
        </div>
        <div className="tableContainer">
          <Table
            onPageChange={handlePageChange}
            onChangeSearch={setSearch}
            pagination={data}
            itemsPerPage={limit} //6
            handleOpenModal={handleOpenModal}
            columns={columnsAccessConfig}
            Actions={Actions as any}
          />
        </div>
      </div>
      <Modal isOpen={isOpenModal} onClose={onCloseModal}>
        <FormAccessConfig onSubmit={handleSubmit} initialValue={selected} />
      </Modal>
    </>
  )
}

export default AccessConfigPage
